import { appData } from '@/mocks/anime';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src={appData.image}
                alt="51动漫APP界面展示"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-xl">
              {appData.desc}
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
              {appData.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-foreground-700 text-sm">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                  </div>
                  <span className="whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>
            <button className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer">
              <i className="ri-download-2-line text-lg"></i>
              下载51动漫APP
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}